// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/Imulimas.jpg";
import thumb1 from "../assets/images/New-Products/extra/Imulimas2.png";
import thumb2 from "../assets/images/New-Products/Imulimas.jpg";
import thumb3 from "../assets/images/New-Products/new/imulimus.jpeg";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2,thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Imulimus</h2>
              <p className="sub-heading">Calcineurin Inhibitor for treatment of Eczema and Vitiligo</p>
              <h5>Product Overview</h5>
              <p>
                Eczema is a chronic skin condition that causes the skin to become inflamed, itchy, and dry.
                Eczema can cause the skin to become red, bumpy, and thick, and may form blisters or crusts.
                It can also cause severe itching, and rashes that may ooze or bleed. Atopic dermatitis is the most common type of eczema.
                Eczema usually begins in childhood, but anyone can get it at any age. Most children outgrow eczema, but it can be a serious condition for adults.
                Eczema can be triggered by allergies or food sensitivities.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Imulimus?</span>
                </h3>
                <p>
                  Can be used by adults and teenagers 16 and older or as advised by your doctor.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients", "storage", "precautions"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : tab === "storage"
                          ? "STORAGE"
                          : tab === "precautions"
                            ? "PRECAUTIONS"
                            : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Used for the treatment of Vitiligo and Atopic Dermatitis.</li>
                    <li>Smart alternative for sensitive skin.</li>
                    <li>Fast relief from itching and redness.</li>
                    <li>Non-steroidal.</li>
                    <li>Shows no skin-Atrophy.</li>
                    <li>Long-term control.</li>
                    <li>Initiate early treatment.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Tacrolimus ointment is applied to clean, dry, and intact skin twice a day. It is used to treat moderate to severe atopic dermatitis.</li>
                      <li>Can be used by adults and teenagers 16 and older.</li>
                      <li>According to trial data, the 0.1% concentration is more effective than the 0.03% concentration in adults.</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    Tacrolimus: Topical tacrolimus works by calming down this immune response.
                    Tacrolimus is a Calcineurin Inhibitor immunosuppressant which works by selectively
                    inhibiting specific protein called calcineurin, which is involved in the immune response,
                    these drugs disrupt the transcription of IL-2 and other cytokines within T lymphocytes,
                    thereby interfering with T-cell activation, proliferation, and differentiation.
                  </p>
                </div>
              )}
              {activeTab === "storage" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Store at temperatures below 25°Celsius.</li>
                      <li>Replace cap tightly after use.</li>
                    </ul>


                  </p>
                </div>
              )}
              {activeTab === "precautions" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>To be used as directed by the physician.</li>
                      <li>Avoid contact with eyes and mouth.</li>
                      <li>Keep medicine out of reach of children.</li>
                    </ul>

                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
